<template>
  <div :class="$style['pt-distribute-task']" v-loading="loading">
    <pt-page-title :title="title"  v-if="!isBatch">
    </pt-page-title>
    <pt-sub-title title="任务单信息"></pt-sub-title>
    <pt-form-item label="任务单编号：" :labelWidth="labelWidth">
      <!-- {{billDetail ? billDetail.billCode :'--'}} -->
      {{'--'}}
    </pt-form-item>
    <pt-form-item label="开始日期：" :labelWidth="labelWidth">
      <el-date-picker v-model="form.startTime" value-format="timestamp" type="date" placeholder="选择日期" @change="startChange"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="目标日期：" :labelWidth="labelWidth">
      <el-date-picker v-model="form.endTime" type="date" value-format="timestamp"  placeholder="选择日期"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="实验人员：" :labelWidth="labelWidth" :required="true">
      <lab-staff-selector v-model="form.labTester" @getObj="val=>currentTester =val" data-vv-as="实验人员" v-validate="'required'"></lab-staff-selector>
    </pt-form-item>
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input v-model="form.comment" placeholder="请填写备注" type="textarea"></el-input>
    </pt-form-item>
      <template v-if="!isBatch">
        <pt-sub-title :title="tip"></pt-sub-title>
        <template v-if="billId">
          <pt-gene-lab-order v-if="isTask" v-loading="tableLoading" :hideTitle="true" :isDistribute="true" :taskId="billId" :isDialog="true" @selection-change="getSelected" @getAllSize="(val)=>selectedSize = val" ref="table" :noExportOption="true">
            <div slot="otherBtn">
              <el-button type="primary" @click="handleRemove" :loading="removeLoading">移除</el-button>
              <el-button type="primary" @click="showDialog = true">新增</el-button>
            </div>
          </pt-gene-lab-order>
          <pt-gene-lab-order v-else v-loading="tableLoading" :hideTitle="true" :isDistribute="true" :billId="billId" :isDialog="true" @selection-change="getSelected" @getAllSize="(val)=>selectedSize = val" ref="table" :noExportOption="true">
            <div slot="otherBtn">
              <el-button type="primary" @click="handleRemove" :loading="removeLoading">移除</el-button>
              <el-button type="primary" @click="showDialog = true">新增</el-button>
            </div>
          </pt-gene-lab-order>
        </template>
        <pt-gene-lab-order-table v-else :tableLabels="tableLabels" :request-data="getSampledetail" :totalNumber="1" :page-size="2" :table-data="tableData">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="goDetail(scope.row.id)">详情
            </el-button>
          </template>
        </pt-gene-lab-order-table>
        <div class="btns">
          <el-button type="primary" @click="handleDistribute">分派</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </template>
    <!-- 从任务单详情进来时：选择样品 -->
    <select-lab-order-dialog v-if="isTask" :taskId="billId" :filterAssginPre="true" :dialogVisible="showDialog" @close="showDialog = false" @selectData="selectData" :pageSize="5" :selectedKeys="[]" :noExportOption="true"></select-lab-order-dialog>
    <!-- 从委托单单详情进来时：选择样品 -->
    <select-lab-order-dialog v-else :billId="billId" :filterAssginPre="true" :dialogVisible="showDialog" @close="showDialog = false" @selectData="selectData" :pageSize="5" :selectedKeys="[]" :noExportOption="true"></select-lab-order-dialog>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import selectLabOrderDialog from 'cps/common/select-lab-order-dialog.vue'
import ptGeneLabOrder from 'cps/lab-order/pt-gene-lab-order'
import { tableLabels } from 'cps/lab-order/pt-gene-lab-order/lab-order-options.js'
import ptGeneLabOrderTable from 'cps/lab-order/pt-gene-lab-order/pt-gene-lab-order-table'
import labStaffSelector from 'cps/selector/lab-staff-selector.vue'
import { nextTrust } from '../order-status/status'
import { next } from 'cps/lab-order/order-status/status'
import {dateZeroOfDay} from "@/utils/formUtils.js"
// 组件class前缀
const prefixCls = 'pt-distribute-task'

export default {
  name: 'pt-distribute-task',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tip () {
      return `已选择样品（${this.selectedSize}/${this.allSize}）`
    },
    billId () {
      return this.$route.params.billId
    },
    isTask () {
      return this.$route.query.isTask
    },
    orderId () {
      return this.$route.query.orderId
    },
    title () {
      return this.isTask ? '样品任务分派' : '委托单任务分派'
    }
  },
  props: {
    isBatch: {
      type: Boolean,
      default: false
    }
  },
  components: {
    labStaffSelector,
    ptGeneLabOrder,
    selectLabOrderDialog,
    ptGeneLabOrderTable
  },

  data () {
    return {
      labelWidth: '170px',
      billDetail: null,
      selectedSize: 0,
      allSize: 0,
      loading: false,
      tableLoading: false,
      selectedPre: [],
      currentTester: {},
      form: {
      },
      removeLoading: false,
      showDialog: false,
      tableLabels: tableLabels,
      tableData: []
    }
  },
  watch:{
    'billDetail.billCode': {
      handler: function (val,old) {
        if (val !== old && val) {
          const str = `20${val.slice(0, 6)}`.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
          // this.form.startTime = new Date(str)
          let startTime = new Date(str)
          this.$set(this.form, 'startTime', startTime.getTime())
          // this.form.endTime = dateZeroOfDay(this.form.startTime,7)
          this.$set(this.form, 'endTime', dateZeroOfDay(startTime, 8))
        }
      },
    },
  },
  methods: {
    startChange(val){
    },
    goDetail (id) {
      this.$router.push(`/lab-order-detail/${id}`)
    },
    getSampledetail (page, next) {
      this.$store.dispatch('getLabOrderDetail', this.orderId).then((response) => {
        this.tableData = [response.order]
        next()
      }).catch(err => {
        this.$message.error(err || '获取订单信息失败')
      })
    },
    formValidata () {
      return validate(this, this.form)
    },
    distributeOrderFromTask () {
      this.formValidata().then(() => {
        let data = {
          id: this.billId,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          comment: this.form.comment,
          labTester: {
            name: this.currentTester.label,
            organizationUserId: this.currentTester.value,
						signatureImageUrl:this.currentTester.signatureImageUrl
          }
        }
        this.loading = true
        this.$store.dispatch('distributeOrderFromTask', data).then(res => {
          this.$router.go(-1)
        }).catch(err => {
          this.$message.error(err.message || err)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    distributeByOrder () {
      this.formValidata().then(() => {
        let data = {
          orderIds: [this.$route.query.orderId],
          billId: this.billId,
          action: 'ORDER_ASSIGN',
          orderStatusDetail: {
            action: 'ORDER_ASSIGN',
            productionTaskDetail: {
              startTime: this.form.startTime,
              endTime: this.form.endTime,
              comment: this.form.comment,
              labTester: {
                name: this.currentTester.label,
								organizationUserId: this.currentTester.value,
								signatureImageUrl:this.currentTester.signatureImageUrl
              }
            }
          }
        }
        // return next.call(this, data)
        this.loading = true
        next.call(this, data).then(response => {
          this.$router.go(-1)
        }).catch(err => {
          this.$message.error(err.message || err)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleDistribute () {
      // 样品详情中创建任务单
      if (this.$route.query.isFromOrder === 'true') {
        this.distributeByOrder()
        return
      }
      // 任务单详情中，勾选样品进行重新分派
      if (this.isTask === 'true') {
        this.distributeOrderFromTask()
        return
      }
      this.formValidata().then(() => {
        let data = {
          billId: this.billId,
          action: 'BILL_ASSIGN',
          billStatusDetail: {
            action: 'BILL_ASSIGN',
            productionTaskDetail: {
              startTime: this.form.startTime,
              endTime: this.form.endTime,
              comment: this.form.comment,
              labTester: {
                name: this.currentTester.label,
                organizationUserId: this.currentTester.value,
								signatureImageUrl:this.currentTester.signatureImageUrl
              }

            }
          }
        }
        // return next.call(this, data)
        this.loading = true
        nextTrust.call(this, data).then(response => {
          this.$router.push(`/trust-deed-detail/${this.billId}`)
        }).catch(err => {
          this.$message.error(err.message || err)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    cancel () {
      history.go(-1)
    },
    getOrderCountByBill (billId) {
      this.$store.dispatch('getOrderCountByBill', billId).then(res => {
        this.allSize = res.orderCount
        this.billDetail = res.billDTO
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      })
    },
    getOrderCountByTask (billId) {
      this.$store.dispatch('getOrderCountByTask', billId).then(res => {
        this.allSize = res.orderCount
				this.billDetail = res.billDTO
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      })
    },
    getSelected (val) {
      this.selectedPre = val
    },
    handleRemove () {
      if (!this.selectedPre.length) {
        this.$message.warning('请先勾选要移除的样品')
        return
      }
      this.$confirm(`请确认是否将您选择的${this.selectedPre.length}个样品移出该任务单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableLoading = true
        let data = {
          [this.isTask ? 'taskId' : 'billId']: this.billId,
          orderIds: this.selectedPre.map(e => e.id)
        }
        this.$store.dispatch('deleteAssginPre', data).then(res => {
          this.$message.success('操作成功')
          this.$refs.table.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.tableLoading = false
        })
      })
    },
    selectData (val) {
      this.showDialog = false
      if (val.length) {
        this.tableLoading = true
        let data = {
          [this.isTask ? 'taskId' : 'billId']: this.billId,
          orderIds: val.map(e => e.id)
        }
        this.$store.dispatch('addAssginPre', data).then(res => {
          this.$message.success('操作成功')
          this.$refs.table.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.tableLoading = false
        })
      }
    }
  },
  created () {
    if (this.billId) {
      this.isTask ? this.getOrderCountByTask(this.billId) : this.getOrderCountByBill(this.billId)
    } else {
      this.selectedSize = 1
      this.allSize = 1
      if(this.$route.query.billCode){
        this.billDetail = {billCode:this.$route.query.billCode }
      }
      
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-distribute-task{
  :global{
    el-textarea,
    .el-textarea__inner {
      width: 500px;
      font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    }
    .el-select{
      width: 2.2rem;
    }
    .el-textarea{
      width: 3.2rem;
    }
  }
}
</style>
